import React from 'react';
import { TabPane } from 'reactstrap';
import { TABS } from '../..';
import { AutoSizer, List } from 'react-virtualized';
import QueueTag from '../QueueTag';

export const TabChatsInWait = ({
  chats = [],
  queues,
  idNameTags,
  answerConversation
}) => {
  return (
    <TabPane
      tabId={TABS.IN_WAIT}
      style={{
        width: '100%',
        height: '94%'
      }}
    >
      <AutoSizer>
        {({ width, height }) => (
          <List
            style={{
              scrollbarWidth: 'thin',
              margin: '0px',
              padding: '0px'
            }}
            width={width}
            height={height}
            rowHeight={138}
            rowCount={chats?.length || 0}
            rowGetter={({ index }) => chats[index] || {}}
            rowRenderer={({ key, index, style }) => {
              return (
                <>
                  <div key={key} style={style}>
                    <QueueTag
                      key={key}
                      style={style}
                      allQueues={queues}
                      idNameTags={idNameTags}
                      conversation={chats[index]}
                      functionAnswerConversation={answerConversation}
                    />
                  </div>
                </>
              );
            }}
          />
        )}
      </AutoSizer>
    </TabPane>
  );
};
